/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FieldOriginFromJSON, FieldOriginToJSON, SeverityFromJSON, SeverityToJSON, } from './';
export function MetaDataItemFromJSON(json) {
    return MetaDataItemFromJSONTyped(json, false);
}
export function MetaDataItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorDetail': !exists(json, 'errorDetail') ? undefined : json['errorDetail'],
        'fieldName': !exists(json, 'fieldName') ? undefined : json['fieldName'],
        'errorType': !exists(json, 'errorType') ? undefined : json['errorType'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'severity': !exists(json, 'severity') ? undefined : SeverityFromJSON(json['severity']),
        'fieldOrigin': !exists(json, 'fieldOrigin') ? undefined : FieldOriginFromJSON(json['fieldOrigin'])
    };
}
export function MetaDataItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'errorDetail': value.errorDetail,
        'fieldName': value.fieldName,
        'errorType': value.errorType,
        'message': value.message,
        'severity': SeverityToJSON(value.severity),
        'fieldOrigin': FieldOriginToJSON(value.fieldOrigin)
    };
}
